import React from 'react'

import ReseatReturn from '../../components/ReseatReturn/ReseatReturn'

const Return = () => {
  return (
    <div className='continar' style={{height:"300vh"}}>  
    <div>
    <div className='Cover'>     
    
    <h1 className='FLYWITHUS'>FLY WITH US</h1> 
    <p className='DISCOVEROURROUTES'>DISCOVER OUR ROUTES</p>
   
    
         
    <div className="d-flex justify-content-center align-items-start form" >
     <ReseatReturn/>
   </div>
    </div> 
    
    </div> 
   
  
    </div>
  )
}

export default Return